import { webLightTheme } from '@fluentui/react-components';

/**
 * Custom Fluent UI theme for the application.
 *
 * Overrides specific design tokens to meet WCAG 2.0 Level AA accessibility
 * requirements (minimum 4.5:1 contrast ratio for normal text).
 *
 * Token override:
 *   colorPaletteYellowForeground1 – Used by Badge (appearance="tint", color="warning") for
 *   its text color. The default value has insufficient contrast against the pale yellow tint
 *   background. The override (#c74f08) achieves a 4.62:1 ratio against white and 4.60:1
 *   against the yellow tint background, meeting WCAG AA.
 */
export const appTheme: typeof webLightTheme = {
  ...webLightTheme,
  // WCAG AA compliant warning foreground: 4.62:1 contrast ratio on white
  colorPaletteYellowForeground1: '#c74f08',
};
